module.exports = __webpack_public_path__ + "static/img/media_banner.bb12bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/media_banner.png
// module id = SkaW
// module chunks = 8